export enum EmbeddedContentType {
    None = 0,
    HeadScript = 1,
    BodyScript = 2,
    Javascript = 3,
    HtmlScript = 4,
    //The member name is part of the content signature, so it must match Hana.AppEnum.EmbeddedContentType exactly.
    AuthoredComponent = 5,
}

const embeddedContentTypeLabels = new Map<EmbeddedContentType, string>([
  [EmbeddedContentType.HeadScript, "Head Script"],
  [EmbeddedContentType.BodyScript, "Body Script"],
  [EmbeddedContentType.Javascript, "Javascript"],
  [EmbeddedContentType.HtmlScript, "Html Script"],
  [EmbeddedContentType.AuthoredComponent, "Bundled"],
]);

/**
 * The pickable content types, labelled the way the rest of the UI labels them.
 *
 * Not getEnumArray: that shows the enum member name, so this type would read "AuthoredComponent" in the
 * one place an author chooses it and "Bundled" everywhere else.
 */
export const getEmbeddedContentTypeOptions = (): { Key: EmbeddedContentType; Value: string }[] =>
  [...embeddedContentTypeLabels.entries()].map(([key, label]) => ({ Key: key, Value: label }));

/**
 * Whether a type is one of the raw script types, as opposed to an authored (bundled) component.
 * @param contentType
 */
export const isScriptContentType = (contentType: EmbeddedContentType): boolean =>
  contentType !== EmbeddedContentType.AuthoredComponent && contentType !== EmbeddedContentType.None;

/**
 * Human label for an embedded content type.
 * @param contentType
 */
export const getEmbeddedContentTypeLabel = (contentType: EmbeddedContentType): string =>
  embeddedContentTypeLabels.get(contentType) ?? "Not Set";
